import template from './employee_upload_photo.html';
import tr from '../../lib/default-translator.js';
import { global_temp_croppie } from '../../../static/lib/js/savanna_functions/savanna_module_v1.0.js';

class EmployeeCreatePhotoUploadViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.photofile = ko.observable();
		this.leave_type_id = ko.observable();
		this.allowed_values = ko.observableArray([ko.observable('')]);
		this.ll_cycle_date = ko.observable();
		this.available_leave_types = ko.observableArray();
		this.imageData = ko.observable();
	};

	close()
	{
		this.dialog.close();
	}
	
	result_click()
	{
		global_temp_croppie.result({
			type: 'canvas',
			size: 'viewport',
			format: 'jpeg',
		}).then((resp) => {
			this.imageData(resp);
			this.uploadClick();
		}).catch(error => {
			console.error('Error getting image from Croppie:', error);
			Grape.alerts.alert({ type: 'error', title: tr('Error'), message: tr('Failed to process the image. Please try again.') });
		});
	}

	uploadClick()
	{
			let formData = new FormData()
			formData.append('employee_id', this.page.bindings.employee_id)
			formData.append('imageData', this.imageData())
			$('#upload_btn').button('loading')
			let xhr = new XMLHttpRequest()
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					Grape.alerts.alert({ type: 'success', message: tr('Photo uploaded successfully'), title: tr('Success') })
					location.reload()
					this.dialog.close()
					$('#upload_btn').button('reset')
				}
			}
			xhr.open('post', '/employee/upload_photo', true)
			xhr.setRequestHeader('Accept', 'application/json')
			xhr.setRequestHeader('X-SessionID', localStorage.getItem('session_id'))
			xhr.send(formData)
		
	};

	rotate_image()
	{
		global_temp_croppie.rotate(90)
	};
};

class EmployeeCreatePhotoUploadPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeCreatePhotoUploadViewModel(this);
		this.bindings = bindings;
		this.viewModel.page = this;
	};
};

export default {
	name: 'EmployeeUploadPhoto',
	dialog_class: EmployeeCreatePhotoUploadPage,
	template: template,
	template_filename: 'translation/dialogs/employee_upload_photo',
	provider: 'ps'
};
